module.exports = __webpack_public_path__ + "img/cross-icon.23b273ef.svg";